import { render } from "./MyTasks.vue?vue&type=template&id=61953e9c&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"

import "./MyTasks.vue?vue&type=style&index=0&id=61953e9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61953e9c"]])

export default __exports__